<pay-dialog-title>{{config.title | translate}}</pay-dialog-title>
<pay-dialog-body>
    <button payIconButton icon="close" class="c-icon-btn--sm x-close-save-changes-dialog-icon-button" payDialogClose></button>
    {{config.content | translate}}
</pay-dialog-body>
<pay-dialog-actions class="justify-content-end">
    <pay-button-group 
        class="c-btn-group--gap-2"
        [class.justify-content-center]="config.dontSaveDisabled"
        [class.justify-content-start]="!config.dontSaveDisabled">

        <button payButton class="c-btn--secondary c-btn--wlg"
                *ngIf="!config.dontSaveDisabled"
                [payDialogClose]="true"
                [disabled]="isClosing">
            {{'Common.No'|translate}}
        </button>
        <button payButton type="button"
                class="c-btn--wlg"
                ngClass="{{ config.okButtonClass }}"
                [class.c-btn--primary]="!config.okButtonClass"
                [disabled]="isClosing"
                (click)="process()">
            {{ okButtonTitle |translate}}
        </button>
    </pay-button-group>
</pay-dialog-actions>
